import { Box, Grid, Card, CardContent, Typography } from "@mui/material";

const cardData = [
  {
    title: "MATHXCEL",
    bgColor: "#00B573",
    text: `MATHXCEL: is a global math competition for Grades 1–12 students. Top performers in online preliminaries advance to on-site finals in the USA, competing for medals, certificates, special prizes, and scholarship opportunities.`,
  },
  {
    title: "COGATXCEL",
    bgColor: "#A5CF39",
    text: `CogATXCEL: A cognitive abilities competition for Grades 1–12, testing critical thinking, problem-solving, and mental agility through verbal, quantitative, and nonverbal challenges.`,
  },
  {
    title: "ROBOTIXCEL",
    bgColor: "#FBC12D",
    text: `RobotixCel: A robotics competition for Grades 3–12. Students design and submit innovative robots, with top designs advancing to the global finals in the USA for expert judging.`,
  },
  {
    title: "ARTXCEL",
    bgColor: "#A5CF39",
    text: `XCEL ART: Unleash your creativity! Students submit original artwork digitally, with finalists showcasing their masterpieces to expert judges in a global competition.`,
  },
];

const AboutFive = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 4 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#444", mb: 4 }}
      >
        All Categories
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {cardData.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                textAlign: "center",
                boxShadow: 3,
              }}
            >
              <Box
                sx={{
                  backgroundColor: card.bgColor,
                  py: 1.5,
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", fontWeight: "bold" }}
                >
                  {card.title}
                </Typography>
              </Box>
              <CardContent>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {card.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AboutFive;
